export const COMPANY_NAME = 'CREED HOUSE INC';
export const COMPANY_ADDRESS_FULL = 'PO BOX 602, LANCASTER, OH 43130-0602';
export const COMPANY_LOCATION = 'Lancaster, Ohio';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=PO%20BOX%20602%2C%20LANCASTER%2C%20OH%2043130-0602';

export const COMPANY_FACTS = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'Location', value: COMPANY_LOCATION },
  { label: 'Address Type', value: 'Mailing address' },
];

export const RECORD_ITEMS = [
  {
    label: 'Profile scope',
    title: 'Public business reference',
    body: 'This page presents a concise public profile using only the supplied company name and mailing location.',
  },
  {
    label: 'Location record',
    title: 'Lancaster, Ohio',
    body: 'The provided address places the organization in Lancaster, Ohio for directory and correspondence reference.',
  },
  {
    label: 'Data boundary',
    title: 'Source-limited details',
    body: 'No phone, email, services, leadership, tax status, or operational claims are added because they were not included in the provided file.',
  },
];
